// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.components-UsersList-styles___pageHeaderWrapper--NSIkW {
  display: flex;
  justify-content: space-between;
}

.components-UsersList-styles___clickable--GWrk0 {
  cursor: pointer;
}

.components-UsersList-styles___tableHead--VsgoA {
  color: #1b2432 !important;
  font-weight: 500 !important;
  font-size: 15px !important;
}

.components-UsersList-styles___tableRow--NXt0z:last-child .components-UsersList-styles___tableRowCell--odmID {
      border: none;
    }

.components-UsersList-styles___tableRow--NXt0z:hover {
    background: #f6f6f7;
  }

.components-UsersList-styles___paper--NRiUM {
  position: relative;
}

.components-UsersList-styles___tableRowCell--odmID {
  padding: 4px 24px 4px 24px !important;
  font-size: 15px !important;
  max-width: 180px !important;
  min-width: 140px !important;
  text-overflow: ellipsis;
  overflow: hidden;
}

.components-UsersList-styles___tableRowCellEmail--EQ_RE {
  max-width: 300px !important;
}

.components-UsersList-styles___tableRowCellBirthDate--jlboZ {
  max-width: 70px !important;
}

.components-UsersList-styles___clickable--GWrk0 {
  cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./components/UsersList/styles.pcss"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAII;MACE,YAAY;IACd;;AAGF;IACE,mBAAmB;EACrB;;AAGF;EACE,kBAAkB;AACpB;;AAEA;EACE,qCAAqC;EACrC,0BAA0B;EAC1B,2BAA2B;EAC3B,2BAA2B;EAC3B,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,eAAe;AACjB","sourcesContent":[".pageHeaderWrapper {\n  display: flex;\n  justify-content: space-between;\n}\n\n.clickable {\n  cursor: pointer;\n}\n\n.tableHead {\n  color: #1b2432 !important;\n  font-weight: 500 !important;\n  font-size: 15px !important;\n}\n\n.tableRow {\n  &:last-child {\n    .tableRowCell {\n      border: none;\n    }\n  }\n\n  &:hover {\n    background: #f6f6f7;\n  }\n}\n\n.paper {\n  position: relative;\n}\n\n.tableRowCell {\n  padding: 4px 24px 4px 24px !important;\n  font-size: 15px !important;\n  max-width: 180px !important;\n  min-width: 140px !important;\n  text-overflow: ellipsis;\n  overflow: hidden;\n}\n\n.tableRowCellEmail {\n  max-width: 300px !important;\n}\n\n.tableRowCellBirthDate {\n  max-width: 70px !important;\n}\n\n.clickable {\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pageHeaderWrapper": `components-UsersList-styles___pageHeaderWrapper--NSIkW`,
	"clickable": `components-UsersList-styles___clickable--GWrk0`,
	"tableHead": `components-UsersList-styles___tableHead--VsgoA`,
	"tableRow": `components-UsersList-styles___tableRow--NXt0z`,
	"tableRowCell": `components-UsersList-styles___tableRowCell--odmID`,
	"paper": `components-UsersList-styles___paper--NRiUM`,
	"tableRowCellEmail": `components-UsersList-styles___tableRowCellEmail--EQ_RE`,
	"tableRowCellBirthDate": `components-UsersList-styles___tableRowCellBirthDate--jlboZ`
};
module.exports = ___CSS_LOADER_EXPORT___;
